import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function MessageScreen({
  title,
  description,
  info,
  showHomeButton = false,
}) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    const project = Cookies.get("test_engine_project");
    if (project) {
      navigate(`/${project}/login`);
    } else {
      navigate("/login");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f0fb",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "16px",
            p: { xs: 3, sm: 5 },
            textAlign: "center",
            boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          }}
        >
          {/* Title */}
          <Typography
            sx={{
              fontSize: { xs: "20px", sm: "24px" },
              fontWeight: "bold",
              color: "#1e1e1e",
              mb: 1.5,
            }}
          >
            {title}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: "15px",
              color: "gray",
              mb: info ? 2 : 3,
              lineHeight: 1.6,
            }}
          >
            {description}
          </Typography>

          {/* Optional info badge */}
          {info && (
            <Box
              sx={{
                backgroundColor: "#f0f0fb",
                border: "1px solid #d0d0f0",
                borderRadius: "8px",
                px: 2,
                py: 1.5,
                mb: 3,
              }}
            >
              <Typography sx={{ fontSize: "13px", color: "#3F41D1" }}>
                {info}
              </Typography>
            </Box>
          )}

          {/* Go to Home button */}
          {showHomeButton && (
            <Button
              onClick={handleGoHome}
              variant="contained"
              disableElevation
              sx={{
                backgroundColor: "#3F41D1",
                color: "white",
                borderRadius: "24px",
                px: 5,
                py: 1.1,
                fontSize: "14px",
                textTransform: "none",
                "&:hover": { backgroundColor: "#2d2fb5" },
              }}
            >
              Go to Home
            </Button>
          )}
        </Box>
      </Container>
    </Box>
  );
}
